import { NgModule } from '@angular/core';
import { GenericMatDialogComponent } from './generic-mat-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

@NgModule({
    imports: [
        MatDialogModule,
    ],
    declarations: [GenericMatDialogComponent],
    exports: [GenericMatDialogComponent],
})
export class GenericMatDialogModule
{
}
